import { Dumbbell, BarChart2, MessageCircle, Settings } from 'lucide-react';

// Single source of truth for the client-facing nav destinations, shared by
// BottomNav.jsx (mobile) and ClientProgramView.jsx's desktop top nav — these
// used to be two hand-maintained lists that drifted (one real bug already
// caused by that, plus a dead "History" link with no matching view in
// App.jsx). Nutrition-switch and Logout stay separate since they're actions,
// not `view` destinations.
export const NAV_ITEMS = [
  { view: 'dashboard', label: 'Workout',  Icon: Dumbbell },
  { view: 'stats',     label: 'Stats',    Icon: BarChart2 },
  { view: 'messages',  label: 'Messages', Icon: MessageCircle },
  { view: 'privacy',   label: 'Settings', Icon: Settings },
];
